<div class="modal-overlay" *ngIf="isOpen" (mousedown)="close()">
	<div [class]="'modal-box' + (currentConfig?.cssClass ? ' ' + currentConfig.cssClass : '')" (mousedown)="$event.stopPropagation()">
		<ng-container #modalContent></ng-container>
	</div>
</div>
